import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

const categories = [
  { name: 'Milk & Dairy', id: 'milkAndDairy' },
  { name: 'Breakfast Cereals', id: 'BreakfastCereals' },
  { name: 'Noodles & Pasta', id: 'noodlesAndPasta' },
  { name: 'Oils & Margarine', id: 'oilsAndMargarine' },
  { name: 'Home & Personal Care', id: 'homeAndPersonalCare' },
  { name: 'Spice & Condiments', id: 'spicesAndCondiments' },
  { name: 'Salt & Sugar', id: 'saltAndSugar' },
  { name: 'Malted Drinks & Beverages', id: 'maltedDrinksAndBeverages' },
  { name: 'Baby Care', id: 'babyCare' },
  { name: 'Packaged Foods', id: 'packagedFoods' },
];

const OrderBulk = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cart, setCart] = useState([]);
  const [activeCategory, setActiveCategory] = useState('milkAndDairy');
  const { phonenumber } = useParams();
  const [modalIsOpen, setModalIsOpen] = useState(false); // Modal visibility state
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [updatedPrice, setUpdatedPrice] = useState('');
  const [updatedQuantity, setUpdatedQuantity] = useState('');
   const { id } = useParams();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`https://citi-mobile-app.onrender.com/saleagent/products/${activeCategory}`);
        setProducts(response.data.products);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching products:', error);
        setLoading(false);
      }
    };
    fetchProducts();
  }, [activeCategory]);

  const addToCart = (product) => {
    if (!isInCart(product._id)) {
      setCart([...cart, product]);
    }
  };

  const isInCart = (productId) => cart.some((item) => item._id === productId);

  const handleBulkOrder = async () => {
    try {
      const orderData = {
        phoneNumber: phonenumber,
        products: cart,
        totalAmount: cart.reduce((total, item) => total + item.price, 0),
      };

      const response = await axios.post(
        'https://citi-mobile-app.onrender.com/saleagent/bulk-order'
        `https://citi-mobile-app.onrender.com/saleagent/bulk-order/${id}`
        , 
        
        orderData);
      if (response.data.success) {
        alert('Bulk order placed successfully!');
        setCart([]); // Clear the cart
      }
    } catch (error) {
      console.error('Error placing bulk order:', error);
      alert('Failed to place bulk order');
    }
  };

  const handleEditProduct = (product) => {
    setSelectedProduct(product);
    setUpdatedPrice(product.price);
    setUpdatedQuantity(product.number);
    setModalIsOpen(true); // Show modal
  };


  
  return (
    <div className="p-4 md:p-8 lg:ml-60 max-sm:mt-16">
      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-32 w-32"></div>
        </div>
      ) : (
        <>
          <div>
            <h2 className="text-lg font-semibold mb-4">Product Categories</h2>
            <div className="flex flex-wrap space-x-3 mb-6 mt-16">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setActiveCategory(category.id)}
                  className={`py-2 rounded text-sm w-[100px] h-[50px] ${
                    activeCategory === category.id ? 'bg-blue-600 text-white' : 'bg-gray-200'
                  }`}
                >
                  {category.name}
                </button>
              ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {products.map((product) => (
                <div key={product._id} className="bg-white p-4 shadow-md rounded-lg relative">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="h-40 w-full object-cover mb-4"
                  />
                  <p className="text-sm font-semibold">{product.title}</p>
                  <p className="text-md text-gray-600">${product.price}</p>
                  <p className="text-md text-gray-600">Quantity: {product.number}</p>

                  {/* Edit icon */}
                  <FontAwesomeIcon 
                    icon={faEdit} 
                    className="absolute top-2 right-2 text-gray-500 cursor-pointer" 
                    onClick={() => handleEditProduct(product)} 
                  />

                  <button
                    className={`${
                      isInCart(product._id) ? 'bg-green-500' : 'bg-blue-600'
                    } text-white py-2 px-4 mt-2 w-full rounded`}
                    onClick={() => addToCart(product)}
                    disabled={isInCart(product._id)} 
                  >
                    {isInCart(product._id) ? 'Item Added' : 'Add to Cart'}
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="flex justify-end mt-8">
            <button
              className="bg-blue-600 text-white py-2 px-6 rounded"
              onClick={handleBulkOrder}
              disabled={cart.length === 0} 
            >
              Add Bulk Order
            </button>
          </div>

          {modalIsOpen && (
  <div className="fixed inset-0 flex items-center justify-center z-50">
    <div className="bg-black opacity-50 fixed inset-0"></div>
    <div className="bg-white rounded-lg p-6 z-10 max-w-md mx-auto shadow-lg">
      <h2 className="text-xl font-semibold mb-4">Edit Product</h2>
      <input
        type="number"
        value={updatedQuantity}
        onChange={(e) => setUpdatedQuantity(e.target.value)}
        placeholder="Quantity"
        className="w-full mb-4 p-2 border rounded"
      />
      <input
        type="number"
        value={updatedPrice}
        onChange={(e) => setUpdatedPrice(e.target.value)}
        placeholder="Price"
        className="w-full mb-4 p-2 border rounded"
      />

      <div className="flex justify-between">
        <button onClick={() => setModalIsOpen(false)} className="bg-gray-500 text-white py-2 px-4 rounded ml-2">
          Cancel
        </button>
      </div>
    </div>
  </div>
)}

        </>
      )}
    </div>
  );
};

export default OrderBulk;
